var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 171.42 125.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:url(#e);}.h{fill:url(#d);}.i{fill:url(#f);}.j{fill:url(#c);}.k{fill:url(#b);}.l{fill:#6a6a7c;}.m{fill:#f6cac0;}.n{fill:#fff;}.o{fill:#d87d68;}.p{fill:#d77d66;}.q,.r{fill:#a8a8c6;}.s{fill:#dda097;opacity:.15;}.s,.t{mix-blend-mode:multiply;}.t{fill:#dda69e;opacity:.2;}.u{fill:#151528;}.u,.r,.v,.w{fill-rule:evenodd;}.v{fill:#251e44;}.w{fill:#30305e;}.x{isolation:isolate;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -10206.98,
    y1: 45.75,
    x2: -10231.15,
    y2: 135.12,
    gradientTransform: "translate(-10142.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe3ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc1c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -10221.75,
    y1: 47.67,
    x2: -10232.46,
    y2: 126.11,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -10269.73,
    cy: 64.87,
    fx: -10269.73,
    fy: 64.87,
    r: 0.01,
    gradientTransform: "translate(-10142.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe3ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcbb9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -10240.11,
    y1: 100.6,
    x2: -10241.21,
    y2: 70,
    gradientTransform: "translate(-10142.04) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d87c7f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -10189.61,
    y1: 98.77,
    x2: -10190.72,
    y2: 68.17,
    xlinkHref: "#e"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "96.39 62.11 87.41 61.7 87.41 61.65 87.66 51.23 87.7 49.65 87.7 49.65 87.71 49.44 96.27 51.91 96.26 52.31 96.21 55.53 96.39 62.11",
    style: {
      fill: "#251e44",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.03 61.66 86.05 61.25 86.83 50.81 86.93 49.41 86.95 49.22 95.5 51.69 95.48 52.07 95.29 55.06 95.03 61.66",
    style: {
      fill: "#30305e",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.21 55.53 95.29 55.06 86.51 55.13 86.83 50.81 86.93 49.41 87.7 49.65 87.7 49.65 95.48 52.07 96.26 52.31 96.21 55.53",
    style: {
      fill: "#151528",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.73 61.37 113.89 62.58 68.56 63.1 68.43 60.68 102.57 61.2 113.73 61.37",
    style: {
      fill: "#151528",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.88 53.04 48.69 2.78 137.11 0 136.61 51.86 45.88 53.04",
    style: {
      fill: "#30305e",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.15 53.6 45.88 53.04 136.61 51.86 137.11 0 138.54 1.54 138.44 52.59 48.15 53.6",
    style: {
      fill: "#151528",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73,61.37l.15,1.21-11.14,.13c-.05-.48-.11-1.02-.17-1.51l11.16,.17Z",
    style: {
      fill: "#251e44",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.49 49.07 85.75 50.12 83 50.13 82.93 49.12 85.49 49.07",
    style: {
      fill: "#a8a8c6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.28 48.85 96.16 50.06 86.38 50.12 86.04 49.06 96.28 48.85",
    style: {
      fill: "#a8a8c6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.4 47.69 54 52.96 67.43 52.97 68.15 47.74 55.4 47.69",
    style: {
      fill: "#a8a8c6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.1 .72 136.14 1.21 50.13 3.88 47.86 47.64 47.14 47.63 49.26 3.32 136.1 .72",
    style: {
      fill: "#151528",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.59 60.77 74.54 63.03 80.19 63.01 80.3 60.86 74.59 60.77",
    style: {
      fill: "#a8a8c6",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "10.45 118.76 10.45 125.23 160.75 125.23 160.75 119.06 140.49 119.02 137.59 119.02 10.45 118.76",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.28,121.98s0,.09,0,.14c0,.44,.03,.9,.06,1.35,.04,.61,.09,1.21,.14,1.76h23.27v-6.16l-20.26-.04h-2.9c-.27,.55-.34,1.69-.31,2.96Z",
    style: {
      fill: "#d87d68"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.21 73.35 78.21 73.36 78.28 115.53 133.93 115.53 134.12 102.25 134.18 98.17 134.52 73.17 78.21 73.35",
    style: {
      fill: "#f6cac0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91,70.79l.87,51.19H161.91l2.61-54.11v-.25l-23.4,.12h0l-3.43,.02-3.63,.02-55.8,2.65-9.02,.04-60.58,.31h-1.75Zm62.32,44.75H13.66l-1.21-41.98,55.19-.17h1.59v42.15Zm65.29-42.36l-.35,25-.06,4.08-.19,13.28h-55.65l-.07-42.18h0l56.32-.18Z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.45 73.55 13.66 115.53 69.23 115.53 69.23 73.37 67.65 73.38 12.45 73.55",
    style: {
      fill: "#f6cac0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.87,69.74c-2.17,2.46,24.55,37.36,24.55,37.36,0,0-13.23-15.9-18.82-14.37-5.59,1.53-.36,12.19,.02,13.73,.38,1.53,8.18,11.38,8.18,11.38,0,0-17.1,0-27.02-13.3-9.92-13.3,2.4-36.92,2.4-36.92l10.68,2.11Z",
    style: {
      fill: "#dda097",
      mixBlendMode: "multiply",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.06,74.73c24.05,.62,34.33,46.71,34.33,46.71l-14.96-17.98,10.36,15.56h17.07l-.88-50.48-45.92,6.19Z",
    style: {
      fill: "#dda097",
      mixBlendMode: "multiply",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.51,120.4c-3.84,6.39,2.56,0,2.56,0",
    style: {
      fill: "#dda69e",
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.71,64.87h-.04s.04,0,.04,0Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.42 122.07 163.18 122.07 164.54 68.27 164.58 66.65 164.62 64.95 141.18 64.95 141.16 66.63 141.14 68.27 140.42 122.07",
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.84 121.98 140.42 121.98 141.12 67.75 141.18 64.86 134.09 64.87 134.09 64.95 134.05 67.78 134.52 73.17 134.18 98.17 134.12 102.25 133.93 115.53 133.84 121.98",
    style: {
      fill: "#f6cac0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.78 121.98 140.42 121.98 133.93 115.53 13.66 115.53 7.78 121.98",
    style: {
      fill: "#f6cac0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.48 66.48 8.66 70.78 8.66 70.78 12.45 73.55 67.65 73.38 69.23 73.37 75.41 73.36 78.21 73.35 134.52 73.17 137.68 67.76 141.18 64.86 134.09 64.95 74.97 65.65 67.13 65.75 5.48 66.48",
    style: {
      fill: "#f6cac0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.48 66.48 7.78 121.98 13.66 115.53 12.45 73.55 8.66 70.78 8.66 70.78 5.48 66.48",
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.51 74.56 80.63 75.82 79.68 115.53 78.29 115.53 78.29 73.36 134.52 73.17 134.51 74.56",
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.44 74.84 14.19 76.13 14.81 115.53 13.42 115.53 12.45 73.75 70.46 73.55 70.44 74.84",
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.54 65.97 69.23 121.98 78.29 121.98 78.28 115.53 79.06 72.91 78.25 70.43 77.78 65.65 67.54 65.97",
    style: {
      fill: "#f6cac0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.59 65.7 74.3 121.98 73.76 121.98 72.88 65.65 73.59 65.7",
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "96.21 73.67 134.13 101.19 134.18 98.17 100.18 73.55 96.21 73.67",
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.19 97.16 100.73 73.17 96.76 73.3 134.15 100.24 134.19 97.16",
    style: {
      fill: "#f6cac0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.13 73.71 95.96 73.71 95.96 73.29 101.84 73.29 102.13 73.71",
    style: {
      fill: "url(#e)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "51.03 74.05 13.1 101.13 13.06 98.55 47.06 73.92 51.03 74.05",
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.05 97.53 46.51 73.55 50.48 73.67 13.06 100.07 13.05 97.53",
    style: {
      fill: "#f6cac0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.38 74.08 51.55 74.08 51.55 73.67 45.67 73.67 45.38 74.08",
    style: {
      fill: "url(#f)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.44,
    y: 122.12,
    width: 150.31,
    height: 1.35,
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.79,72.13c0,1.32,.68,2.39,1.53,2.39s1.53-1.07,1.53-2.39-.68-2.39-1.53-2.39-1.53,1.07-1.53,2.39Z",
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.62,69.59c-.6,.27-2.3,0-2.3,0l.13,1.76,1.95,.39s.84-.42,.79-1.15c-.05-.73-.57-.99-.57-.99Z",
    style: {
      fill: "#6a6a7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.43,70.54c0,1.11,.79,2.01,1.77,2.01s1.77-.9,1.77-2.01-.79-2.01-1.77-2.01-1.77,.9-1.77,2.01Z",
    style: {
      fill: "#a8a8c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.08,68.84c-.81-.15-1.14,.6-1.14,.6,0,0,.45-.06,.81-.2,.35-.14,.33-.4,.33-.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.98,
    cy: 72.34,
    rx: 1.53,
    ry: 2.39,
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.28,69.8c-.6,.27-2.3,0-2.3,0l.13,1.76,1.95,.39s.84-.42,.79-1.15c-.05-.73-.57-1-.57-1Z",
    style: {
      fill: "#6a6a7c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.86,
    cy: 70.75,
    rx: 1.77,
    ry: 2.01,
    style: {
      fill: "#a8a8c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74,69.05c-.81-.15-1.14,.6-1.14,.6,0,0,.45-.06,.81-.2,.35-.14,.33-.4,.33-.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: 62.32,
    width: 171.42,
    height: 4.33,
    style: {
      fill: "#f6cac0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.16 66.65 171.42 66.65 171.42 62.32 148.41 62.32 148.16 66.65",
    style: {
      fill: "#d77d66"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.89 122.12 143.23 66.65 144.68 66.65 142.55 122.12 141.89 122.12",
    style: {
      fill: "#f6cac0"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.f09a7468d62ba52b65fbe49c1ae3de8e.svg";
export { ForwardRef as ReactComponent };